const data = [{
    key: '5.3_spiral_abyss_upper',
    name: '5.3深渊上半',
    time: '2025-01-16~2025-02-15',
    scores: [
        {
            uid: '515292393',
            name: '烟绯三月夏扬州',
            team: [
                ['烟绯', 6, '万世流涌大典', 1],
                ['芙宁娜', 2, '西风剑', 5],
                ['希诺宁', 3, '西风剑', 5],
                ['茜特菈莉', 2, '祭星者之望', 1],
            ],
            time: 101,
            cost: 12,
            video: 'https://www.bilibili.com/video/BV1yuwMedEWX/',
        },
        {
            uid: '117979290',
            name: '倒立享受人参',
            team: [
                ['烟绯', 6, '万世流涌大典', 1],
                ['班尼特', 6, '风鹰剑', 1],
                ['芙宁娜', 3, '西风剑', 5],
                ['茜特菈莉', 6, '祭星者之望', 1],
            ],
            time: 88,
            cost: 14,
            video: 'https://www.bilibili.com/video/BV1hkwWeJEqN/',
        },
        {
            uid: '103785209',
            name: '-临夜-',
            team: [
                ['烟绯', 6, '流浪乐章', 5],
                ['班尼特', 6, '雾切之回光', 5],
                ['希诺宁', 6, '岩峰巡歌', 5],
                ['茜特菈莉', 6, '祭星者之望', 5],
            ],
            time: 31,
            cost: 29,
            video: 'https://www.bilibili.com/video/BV1TZPBepEw6/',
        },
        {
            uid: '173898921',
            name: '盉本空',
            team: [
                ['烟绯', 6, '流浪乐章', 5],
                ['班尼特', 6, '暗巷闪光', 5],
                ['砂糖', 6, '祭礼残章', 5],
                ['行秋', 6, '西风剑', 5],
            ],
            time: 219,
            cost: 0,
            video: 'https://www.bilibili.com/video/BV1BcwaeJE6F/',
        },
        {
            uid: '173898921',
            name: '和彩彩',
            team: [
                ['烟绯', 6, '万世流涌大典', 5],
                ['芙宁娜', 6, '圣显之钥', 5],
                ['希诺宁', 6, '岩峰巡歌', 5],
                ['茜特菈莉', 6, '祭星者之望', 5],
            ],
            time: 43,
            cost: 41,
            video: 'https://www.bilibili.com/video/BV1BEPXeLE2D/',
        },
    ],
}, {
    key: '5.4_spiral_abyss_upper',
    name: '5.4深渊上半',
    time: '2025-02-16~2025-03-15',
    scores: [
        {
            uid: '515292393',
            name: '烟绯三月夏扬州',
            team: [
                ['烟绯', 6, '万世流涌大典', 1],
                ['芙宁娜', 2, '西风剑', 5],
                ['希诺宁', 3, '西风剑', 5],
                ['茜特菈莉', 2, '祭星者之望', 1],
            ],
            time: 139,
            cost: 12,
            video: 'https://www.bilibili.com/video/BV1wWAueFERC/',
        },
        {
            uid: '117979290',
            name: '倒立享受人参',
            team: [
                ['烟绯', 6, '万世流涌大典', 1],
                ['班尼特', 3, '雾切之回光', 1],
                ['芙宁娜', 3, '西风剑', 5],
                ['茜特菈莉', 6, '祭星者之望', 1],
            ],
            time: 79,
            cost: 14,
            video: 'https://www.bilibili.com/video/BV1GmA3eHEAU/',
        },
        {
            uid: '103785209',
            name: '-临夜-',
            team: [
                ['烟绯', 6, '流浪乐章', 5],
                ['班尼特', 6, '雾切之回光', 5],
                ['希诺宁', 6, '岩峰巡歌', 5],
                ['茜特菈莉', 6, '祭星者之望', 5],
            ],
            time: 38,
            cost: 29,
            video: 'https://www.bilibili.com/video/BV1PDAxe1ECH/',
        },
        {
            uid: '515292393',
            name: '烟绯三月夏扬州',
            team: [
                ['烟绯', 6, '金流监督', 5],
                ['芙宁娜', 6, '静水流涌之辉', 4],
                ['希诺宁', 3, '西风剑', 5],
                ['茜特菈莉', 2, '祭星者之望', 1],
            ],
            time: 93,
            cost: 24,
            video: 'https://www.bilibili.com/video/BV1d19HYFE1M/',
        },
        {
            uid: '203015130',
            name: '-思夏忆欢-',
            team: [
                ['烟绯', 6, '流浪乐章', 5],
                ['班尼特', 6, '天空之刃', 5],
                ['枫原万叶', 2, '西风剑', 5],
                ['芙宁娜', 6, '静水流涌之辉', 1],
            ],
            time: 132,
            cost: 12,
            video: 'https://www.bilibili.com/video/BV1S3RNYGEzi/',
        },
    ],
}, {
    key: '5.4_spiral_abyss_lower',
    name: '5.4深渊下半',
    time: '2025-02-16~2025-03-15',
    scores: [
        {
            uid: '114460799',
            name: '捡起肥皂硬又黑',
            team: [
                ['烟绯', 6, '流浪乐章', 5],
                ['芙宁娜', 6, '圣显之钥', 1],
                ['闲云', 2, '鹤鸣余音', 1],
                ['茜特菈莉', 6, '祭星者之望', 1],
            ],
            time: 48,
            cost: 20,
            video: 'https://www.bilibili.com/video/BV1BZwSeNEyc/',
        },
        {
            uid: '117979290',
            name: '倒立享受人参',
            team: [
                ['烟绯', 6, '万世流涌大典', 1],
                ['班尼特', 3, '雾切之回光', 1],
                ['芙宁娜', 3, '西风剑', 5],
                ['茜特菈莉', 6, '祭星者之望', 1],
            ],
            time: 78,
            cost: 14,
            video: 'https://www.bilibili.com/video/BV1eDwXeiE3B/',
        },
    ],
}, {
    key: '5.4_spiral_abyss_upper_2',
    name: '5.4深渊二期上半',
    time: '2025-03-16~2025-04-15',
    scores: [
        {
            uid: '103785209',
            name: '-临夜-',
            team: [
                ['烟绯', 6, '流浪乐章', 5],
                ['芙宁娜', 6, '圣显之钥', 5],
                ['希诺宁', 6, '岩峰巡歌', 5],
                ['茜特菈莉', 6, '祭星者之望', 5],
            ],
            time: 68,
            cost: 41,
            video: 'https://www.bilibili.com/video/BV17aQxYBE35/',
        },
        {
            uid: '515292393',
            name: '烟绯三月夏扬州',
            team: [
                ['烟绯', 6, '金流监督', 5],
                ['芙宁娜', 6, '静水流涌之辉', 4],
                ['希诺宁', 3, '西风剑', 5],
                ['茜特菈莉', 2, '祭星者之望', 1],
            ],
            time: 139,
            cost: 24,
            video: 'https://www.bilibili.com/video/BV1d19HYFE1M/',
        },
        {
            uid: '203015130',
            name: '-思夏忆欢-',
            team: [
                ['烟绯', 6, '金流监督', 1],
                ['枫原万叶', 2, '西风剑', 5],
                ['芙宁娜', 6, '静水流涌之辉', 1],
                ['行秋', 6, '祭礼剑', 5],
            ],
            time: 166,
            cost: 12,
            video: 'https://www.bilibili.com/video/BV1G6QxYAEVJ/',
        },
        {
            uid: '117979290',
            name: '倒立享受人参',
            team: [
                ['烟绯', 6, '万世流涌大典', 1],
                ['枫原万叶', 2, '苍古自由之誓', 1],
                ['芙宁娜', 6, '磐岩结绿', 1],
                ['茜特菈莉', 6, '祭星者之望', 1],
            ],
            time: 118,
            cost: 21,
            video: 'https://www.bilibili.com/video/BV126QhYqEBH/',
        },
    ],
}, {
    key: '5.4_spiral_abyss_lower_2',
    name: '5.4深渊二期下半',
    time: '2025-03-16~2025-04-15',
    scores: [
        {
            uid: '114460799',
            name: '捡起肥皂硬又黑',
            team: [
                ['烟绯', 6, '流浪乐章', 5],
                ['班尼特', 6, '雾切之回光', 1],
                ['茜特菈莉', 6, '祭星者之望', 1],
                ['闲云', 2, '鹤鸣余音', 1],
            ],
            time: 29,
            cost: 12,
            video: 'https://www.bilibili.com/video/BV1J6XKYsEVm/',
        },
        {
            uid: '114460799',
            name: '捡起肥皂硬又黑',
            team: [
                ['烟绯', 6, '流浪乐章', 5],
                ['班尼特', 6, '雾切之回光', 1],
                ['茜特菈莉', 6, '祭星者之望', 1],
                ['闲云', 2, '鹤鸣余音', 1],
            ],
            time: 33,
            cost: 12,
            video: 'https://www.bilibili.com/video/BV19xQbYuEpo/',
        },
        {
            uid: '114460799',
            name: '捡起肥皂硬又黑',
            team: [
                ['烟绯', 6, '流浪乐章', 5],
                ['芙宁娜', 6, '圣显之钥', 1],
                ['茜特菈莉', 6, '祭星者之望', 1],
                ['闲云', 2, '鹤鸣余音', 1],
            ],
            time: 39,
            cost: 20,
            video: 'https://bilibili.com/video/BV19xQbYuEpo/',
        },
        {
            uid: '515292393',
            name: '烟绯三月夏扬州',
            team: [
                ['烟绯', 6, '金流监督', 5],
                ['芙宁娜', 6, '静水流涌之辉', 4],
                ['希诺宁', 3, '西风剑', 5],
                ['茜特菈莉', 2, '祭星者之望', 1],
            ],
            time: 73,
            cost: 24,
            video: 'https://www.bilibili.com/video/BV12CQhYvEsN/',
        },
    ],
}, {
    key: '5.5_spiral_abyss_upper',
    name: '5.5深渊上半',
    time: '2025-04-16~2025-05-15',
    scores: [
        {
            uid: '103785209',
            name: '-临夜-',
            team: [
                ['烟绯', 6, '溢彩心念', 5],
                ['希诺宁', 6, '岩峰巡歌', 5],
                ['茜特菈莉', 6, '祭星者之望', 5],
                ['闲云', 2, '鹤鸣余音', 5],
            ],
            time: 32,
            cost: 37,
            video: 'https://www.bilibili.com/video/BV17aQxYBE35/',
        },
        {
            uid: '114460799',
            name: '捡起肥皂硬又黑',
            team: [
                ['烟绯', 6, '流浪乐章', 5],
                ['希诺宁', 4, '息燧之笛', 5],
                ['茜特菈莉', 6, '祭星者之望', 1],
                ['闲云', 2, '鹤鸣余音', 1],
            ],
            time: 50,
            cost: 17,
            video: 'https://www.bilibili.com/video/BV1w65azjEeJ/',
        },
        {
            uid: '515292393',
            name: '烟绯三月夏扬州',
            team: [
                ['烟绯', 6, '学徒笔记', 1],
                ['芙宁娜', 6, '静水流涌之辉', 4],
                ['千织', 6, '有乐御簾切', 1],
                ['希诺宁', 3, '西风剑', 5],
            ],
            time: 93,
            cost: 23,
            video: 'https://www.bilibili.com/video/BV1rNoAYxEJg/',
        },
        {
            uid: '203015130',
            name: '-思夏忆欢-',
            team: [
                ['烟绯', 6, '四风原典', 1],
                ['八重神子', 0, '金流监督', 1],
                ['玛薇卡', 0, '狼的末路', 2],
                ['夏沃蕾', 6, '西风长枪', 5],
            ],
            time: 230,
            cost: 6,
            video: 'https://www.bilibili.com/video/BV1Ro5ezGEN2/',
        },
        {
            uid: '',
            name: '穿越stars',
            team: [
                ['烟绯', 6, '溢彩心念', 1],
                ['芙宁娜', 2, '有乐御簾切', 1],
                ['希诺宁', 0, '西风剑', 5],
                ['香菱', 6, '「渔获」', 5],
            ],
            time: 250,
            cost: 6,
            video: 'https://www.bilibili.com/video/BV1JaoKYvEjs/',
        },
    ],
}, {
    key: '5.5_spiral_abyss_lower',
    name: '5.5深渊下半',
    time: '2025-04-16~2025-05-15',
    scores: [
        {
            uid: '515292393',
            name: '烟绯三月夏扬州',
            team: [
                ['烟绯', 6, '金流监督', 5],
                ['芙宁娜', 6, '静水流涌之辉', 4],
                ['希诺宁', 4, '岩峰巡歌', 1],
                ['茜特菈莉', 2, '祭星者之望', 1],
            ],
            time: 121,
            cost: 26,
            video: 'https://www.bilibili.com/video/BV1SUowYTEw8/',
        },
        {
            uid: '203015130',
            name: '-思夏忆欢-',
            team: [
                ['烟绯', 6, '金流监督', 1],
                ['芙宁娜', 6, '静水流涌之辉', 1],
                ['纳西妲', 0, '流浪的晚星', 2],
                ['钟离', 0, '黑缨枪', 5],
            ],
            time: 238,
            cost: 9,
            video: 'https://www.bilibili.com/video/BV1oGLMz3Ei2/',
        },
    ],
}, {
    key: '5.6_spiral_abyss_upper',
    name: '5.6深渊上半',
    time: '2025-05-16~2025-06-15',
    scores: [
        {
            uid: '515292393',
            name: '烟绯三月夏扬州',
            team: [
                ['烟绯', 6, '金流监督', 5],
                ['芙宁娜', 6, '静水流涌之辉', 4],
                ['希诺宁', 4, '岩峰巡歌', 1],
                ['茜特菈莉', 2, '祭星者之望', 1],
            ],
            time: 79,
            cost: 26,
            video: 'https://www.bilibili.com/video/BV182ExzQEyg/',
        },
        {
            uid: '114460799',
            name: '捡起肥皂硬又黑',
            team: [
                ['烟绯', 6, '流浪乐章', 5],
                ['希诺宁', 4, '息燧之笛', 5],
                ['茜特菈莉', 6, '祭星者之望', 1],
                ['闲云', 2, '鹤鸣余音', 1],
            ],
            time: 66,
            cost: 17,
            video: 'https://www.bilibili.com/video/BV119EWzuEPq/',
        },
        {
            uid: '277909571',
            name: '昵称违规已经被处理',
            team: [
                ['烟绯', 6, '万世流涌大典', 1],
                ['芙宁娜', 1, '有乐御簾切', 1],
                ['希诺宁', 2, '岩峰巡歌', 1],
                ['夜兰', 0, '西风猎弓', 3],
            ],
            time: 216,
            cost: 9,
            video: 'https://www.bilibili.com/video/BV1DAEtzfEXH/',
        },
        {
            uid: '114460799',
            name: '捡起肥皂硬又黑',
            team: [
                ['烟绯', 6, '流浪乐章', 5],
                ['班尼特', 6, '雾切之回光', 1],
                ['希诺宁', 4, '息燧之笛', 5],
                ['茜特菈莉', 6, '祭星者之望', 1],
            ],
            time: 57,
            cost: 14,
            video: 'https://www.bilibili.com/video/BV1hSJwzxEWS/',
        },
        {
            uid: '117979290',
            name: '倒立享受人参',
            team: [
                ['烟绯', 6, '万世流涌大典', 1],
                ['班尼特', 3, '雾切之回光', 1],
                ['芙宁娜', 3, '西风剑', 5],
                ['茜特菈莉', 6, '祭星者之望', 1],
            ],
            time: 85,
            cost: 14,
            video: 'https://www.bilibili.com/video/BV1WfJFzrEWc/',
        },
        {
            uid: '203015130',
            name: '-思夏忆欢-',
            team: [
                ['烟绯', 6, '金流监督', 1],
                ['爱可菲', 0, '天空之脊', 2],
                ['枫原万叶', 2, '西风剑', 5],
                ['芙宁娜', 6, '静水流涌之辉', 1],
            ],
            time: 152,
            cost: 13,
            video: 'https://www.bilibili.com/video/BV19NJPzPEAU/',
        },
        {
            uid: '225612892',
            name: '龙龙x烟绯',
            team: [
                ['烟绯', 6, '万世流涌大典', 1],
                ['班尼特', 4, '原木刀', 2],
                ['芙宁娜', 1, '赦罪', 1],
                ['茜特菈莉', 0, '祭礼残章', 5],
            ],
            time: 270,
            cost: 4,
            video: 'https://www.bilibili.com/video/BV1nFjHzDEcz/',
        },
    ],
}];

export default data;